// extracted by mini-css-extract-plugin
module.exports = {"flexDiv":"demo-module--flexDiv--2RxiI","flexCol":"demo-module--flexCol--1B2_p"};